import React, { memo, useMemo } from 'react';
import { parseLexicalJSON, isLexicalJSON } from '@/lib/lexical-parser';
import Colors from '@/constants/colors';

interface LexicalRendererProps {
  content: string;
  fallbackClassName?: string;
}

const fallbackStyle: React.CSSProperties = {
  fontSize: '16px',
  lineHeight: '24px',
  color: Colors.text,
  margin: 0,
  whiteSpace: 'pre-wrap',
};

function LexicalRendererComponent({ content, fallbackClassName }: LexicalRendererProps) {
  const rendered = useMemo(() => {
    if (!content) {
      return null;
    }

    // Check if content is Lexical JSON
    if (isLexicalJSON(content)) {
      return parseLexicalJSON(content);
    }

    // Fallback to plain text
    return (
      <p style={fallbackStyle} className={fallbackClassName}>
        {content}
      </p>
    );
  }, [content, fallbackClassName]);

  return <>{rendered}</>;
}

export const LexicalRenderer = memo(LexicalRendererComponent);
